'use strict';

var React = require("react");

((require("../styles/empty-builder.css")));

function EmptyBuilder(Props) {
  return React.createElement("div", {
              className: "container"
            }, React.createElement("div", {
                  className: "logo"
                }), React.createElement("span", {
                  className: "title"
                }, "Form Builder"));
}

var make = EmptyBuilder;

exports.make = make;
/*  Not a pure module */
